package navigation.home.crm

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.navigator.tab.TabOptions
import cafe.adriel.voyager.transitions.SlideTransition
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.esIconPainterResource
import navigation.utils.NavLinkTab

object CRMScreenTab : NavLinkTab {

    override var innerNavigator: Navigator? by mutableStateOf(null)

    override val options: TabOptions
        @Composable
        get() {
            val title = "Contacts"
            val icon = esIconPainterResource(EsIcons.Suppliers)
            val index: UShort = 8u

            return TabOptions(
                index, title, icon,
            )
        }

    @Composable
    override fun Content() {
        Navigator(CRMScreenNav) { navigator ->

            DisposableEffect(navigator) {
                innerNavigator = navigator

                onDispose {
                    innerNavigator = null
                }
            }

            SlideTransition(navigator)
        }
    }
}